<template>
  <v-card class="ma-2">
    <v-toolbar color="primary" dark flat dense>
      <v-toolbar-side-icon></v-toolbar-side-icon>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshData(url)">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-menu bottom left offset-y>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile @click="">Refresh</v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <connection-manager ref="connectionManager"></connection-manager>
    <v-card-text v-if="chartData">
      <stats-pie-chart
        v-if="chartType === 'pie'"
        :chartData="chartData"
      ></stats-pie-chart>
      <stats-bar-chart
        v-if="chartType === 'bar'"
        v-bind:chartData="chartData"
      ></stats-bar-chart>
    </v-card-text>
  </v-card>
</template>

<script>
import StatsPieChart from './StatsPieChart'
import ConnectionManager from './ConnectionManager'
import { mapActions } from 'vuex'
import StatsBarChart from './StatsBarChart'

export default {
  components: { StatsBarChart, ConnectionManager, StatsPieChart },
  name: 'stats-card',
  props: {
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    chartType: {
      type: String,
      default: 'pie'
    }
  },
  data() {
    return {}
  },
  computed: {
    chartData() {
      return this.$store.getters['charts/getDataByFilter'](this.url)
    }
  },
  methods: {
    ...mapActions('charts', ['refreshData'])
  },
  created() {
    this.$store.dispatch('charts/loadData', this.url)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/StatsCard.vue